<script>
	// NPM Modules
	import dayjs from 'dayjs';
	import localizedFormat from 'dayjs/plugin/localizedFormat';
	// Stores
	import RaceStore from '@/Stores/Racing/RaceStore.js';
	// Components
	import Modal from '@/Components/Modal.svelte';
	import FontIcon from '@/Components/FontIcon.svelte';
	// Partials
	import VisibilityRow from '@/Partials/Racing/Meeting/_VisibilityRow.svelte';
	import VisibilityMeeting from '@/Partials/Racing/Meeting/_VisibilityMeeting.svelte';
	import BoostableMeeting from '@/Partials/Racing/Meeting/_BoostableMeeting.svelte';
	import BonusDisabledMeeting from '@/Partials/Racing/Meeting/_BonusDisabledMeeting.svelte';
	import CashoutEnabledMeeting from '@/Partials/Racing/Meeting/_CashOutMeeting.svelte';

	dayjs.extend(localizedFormat);

	export let open = false;
	export let meeting = undefined;
</script>

{#if open && meeting}
	<Modal on:close={() => (open = false)} className="mx-2 md:w-2/3 md:mx-auto">
		<div class="pt-2 font-semibold text-center uppercase" slot="header">
			Manage Visibility for {meeting.name}
		</div>
		<!-- MEETING -->
		<div class="flex items-center w-full px-4 py-4 mb-4 border-b">
			<FontIcon icon={meeting.race_type.name.toLowerCase()} />
			<div class="ml-1 text-lg font-bold">{meeting.name}</div>
			<div class="ml-2">{dayjs(meeting.start_date).format('LL')}</div>
			<VisibilityMeeting meeting={meeting && meeting} />
			<BoostableMeeting meeting={meeting && meeting} />
			<BonusDisabledMeeting meeting={meeting && meeting} />
			<CashoutEnabledMeeting meeting={meeting && meeting} />
		</div>
		<!-- ALL RACES -->
		{#if meeting.visible}
			{#if $RaceStore.where('meeting_id', meeting.id).count() == 0}
				<div class="py-4 text-center">This meeting has no races.</div>
			{:else}
				<div class="table w-full px-4 mt-2 mb-4 text-center table-auto">
					<div class="table-row-group">
						<div class="table-row font-bold uppercase">
							<div class="table-cell px-1 py-2">Race</div>
							<div class="table-cell px-1 text-left">Name</div>
							<div class="table-cell px-1">Start Time</div>
							<div class="table-cell px-1">Visible</div>
							<div class="table-cell px-1">Featured</div>
							<div class="table-cell px-1">Boost Up</div>
							<div class="table-cell px-1">Bonus Bets</div>
							<!--<div class="table-cell px-1">Cash Out</div> // Hidden till they ask to be able to do this at race level-->
						</div>
					</div>
					<div class="table-row-group">
						{#each $RaceStore.where('meeting_id', meeting.id).sortBy('race_number').all() as race (race.id)}
							<VisibilityRow {race} {meeting} />
						{/each}
					</div>
				</div>
			{/if}
		{:else}
			<div class="py-4 text-center">Meeting must be visible to edit races visibility.</div>
		{/if}
	</Modal>
{/if}
